(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blindstyle-ajax-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    // Upsell Product Data
    const upsellProducts = {
      'fitfix-toggle': {
        id: 42846393401516, // FitFix product ID
        storageKey: 'fitfixAdded'
      },
      '48h-despatch-toggle': {
        id: 43606378348716, // 48hr Despatch product ID
        storageKey: 'despatch48hAdded'
      }
    };

    // Function to handle adding/removing upsell products
    function handleUpsellToggle(checkboxId) {
      const checkbox = document.getElementById(checkboxId);
      const productData = upsellProducts[checkboxId];

      // Load checkbox state from localStorage
      const storedState = localStorage.getItem(productData.storageKey);
      if (storedState === 'true') {
        checkbox.checked = true;
        addProductToCart(productData.id, false); 
      } else if (storedState === 'false') {
        checkbox.checked = false;
        removeProductFromCart(productData.id);
      }

      checkbox.addEventListener('change', function () {
        if (this.checked) {
          addProductToCart(productData.id, true);
          localStorage.setItem(productData.storageKey, 'true');
        } else {
          removeProductFromCart(productData.id);
          localStorage.setItem(productData.storageKey, 'false');
        }
      });
    }

    // Add product to cart (with check for duplicates)
    function addProductToCart(productId, allowAdding = true) {
      const isProductInCart = window.liquidAjaxCart.cart.items.some(
        (item) => item.variant_id === productId
      );

      if (!isProductInCart && allowAdding) {
        window.liquidAjaxCart.add(
          {
            id: productId,
            quantity: 1,
          }
        );
      }
    }

    // Remove product from cart
    function removeProductFromCart(productId) {
      const productLineItem = window.liquidAjaxCart.cart.items.find(
        (item) => item.variant_id === productId
      );

      if (productLineItem) {
        window.liquidAjaxCart.change(
          {
            id: productLineItem.key,
            quantity: 0,
          }
        );
      }
    }

    // Initialize both upsell toggles
    handleUpsellToggle('fitfix-toggle');
    handleUpsellToggle('48h-despatch-toggle');

    // Function to restore cart from localStorage
    function restoreCart() {
      const savedItems = localStorage.getItem('savedCartItems');
      if (savedItems) {
        const itemsToAdd = JSON.parse(savedItems);
        // console.log("Restoring cart items:", itemsToAdd);
    
        window.liquidAjaxCart.add(
          {
            items: itemsToAdd
          },
          {
            lastCallback: function (requestState) {
              // console.log("requestState object:", requestState); 
    
              // Check for success using requestState.responseData.status
              if (requestState && requestState.responseData && requestState.responseData.status === 200) { 
                // console.log("Cart items restored successfully.");
                localStorage.removeItem('savedCartItems'); // Clear saved cart data
              } else {
                // console.error("Error restoring cart items:", requestState); 
              }
            },
            important: true
          }
        );
      }
    }
    
    // Check for saved cart items on page load
    if (localStorage.getItem('savedCartItems')) {
      // console.log("Saved cart items found, clearing cart and restoring...");

      // Use fetch to clear the entire cart using /cart/clear.js
      fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST' 
      })
      .then(response => {
        if (response.ok) {
          // console.log("Cart cleared successfully using /cart/clear.js");
          restoreCart(); // Restore the cart after clearing
        } else {
          // console.error("Error clearing cart:", response.status, response.statusText);
        }
      })
      .catch(error => {
        // console.error("Error during cart clearing:", error);
      });
    }
    
    // Function to remove upsells and update states directly
    function removeUpsellsAndSync() {
      for (const checkboxId in upsellProducts) {
        const productData = upsellProducts[checkboxId];
        const checkbox = document.getElementById(checkboxId);

        // Remove from cart
        removeProductFromCart(productData.id);

        // Update checkbox and localStorage without triggering change event
        checkbox.checked = false; 
        localStorage.setItem(productData.storageKey, 'false');
      }
    }

    // Mutation to remove upsell products if .cart-has-shutters exists
    function removeUpsellIfShutters() {
      if (document.querySelector('.cart-has-shutters')) {
        // Call the function to remove upsells and sync states
        removeUpsellsAndSync(); 
      }
    }

    // Add the mutation to Liquid Ajax Cart
    window.liquidAjaxCart.conf('mutations', [removeUpsellIfShutters]);

  });

  } catch(e) { console.error(e); }
})();
})();
